import React, { useEffect, useState, useMemo, useCallback } from "react";
import TextBox from "../../../../components/forms/text-box";
import { SYS_LANGUAGE_SELECTED_SLOT } from "../../common/const/settings-const";
import { QUESTION_PROMPT } from "../../common/const/settings-type";
import SettingTip from "../../common/components/setting-tip";
import { LANGUAGES } from "../../../../consts/languages";
import MultiSelect from "../../../../components/forms/multi-select-drop-down";
import DisplayTexts from "../../common/components/display-texts";

function Page({ id: stepId, name, onChangeData, savedSettings, metadata }) {
  const [formData, setFormData] = useState(savedSettings);

  const notifyOnchangeData = data => {
    data.slot = SYS_LANGUAGE_SELECTED_SLOT;
    data.stateType = QUESTION_PROMPT;
    onChangeData(data);
  };

  useEffect(() => {
    notifyOnchangeData(formData);
  }, [formData]);

  const handleChange = useCallback(event => {
    const { name, value } = event.target;

    setFormData(prevFormData => {
      return {
        ...prevFormData,
        [name]: value
      };
    });
  }, []);

  const handleLanguageChange = useCallback((selectedLanguages) => {
    setFormData(prevFormData => {
      return {
        ...prevFormData,
        languages: selectedLanguages
      };
    });
  }, []);

  // Convert languages array to format required by MultiSelect
  const languageOptions = useMemo(() => {
    return LANGUAGES.map((language, index) => ({
      id: language,
      label: language
    }));
  }, []);

  const memoizedDisplayTextOptions = useMemo(() => formData.displayTextOptions, [formData.displayTextOptions]);

  return (
    <div className="flex flex-col gap-2">
      <SettingTip text="Language selector allows users to select multiple languages for their workflow. This component enables multilingual support for your application." />
      <div className="p-4 bg-slate-50 border rounded-md border-slate-200">
        <TextBox
          label="Name"
          type="text"
          name="name"
          placeholder="State name"
          value={formData.name}
          onChange={handleChange}
        />
        <DisplayTexts
          rootClassName="pt-4"
          displayTopBorder={false}
          parameterName={formData.slot}
          displayTextOptionsProps={memoizedDisplayTextOptions}
          responseModifyByAI={formData.responseModifyByAI}
          onChangeData={handleChange}
        />
        <div className="pt-4">
          <MultiSelect
            label="Languages"
            options={languageOptions}
            selectedOptions={formData.languages || []}
            onChangeOptions={handleLanguageChange}
            rootClass="w-full"
          />
        </div>
      </div>
    </div>
  );
}

export default Page;
